// Change the version for a future announcement so returning players see it once.
const VERSION = '2026-10-05-skins-sound';
const STORAGE_KEY = 'web-jump-update-seen';

export default function showUpdateNotice(ui) {
  try {
    if (localStorage.getItem(STORAGE_KEY) === VERSION) return;
  } catch (_) {}

  const dialog = document.createElement('dialog');
  dialog.className = 'notice-dialog update-notice';
  dialog.id = 'update-dialog';
  dialog.setAttribute('aria-labelledby', 'update-title');
  dialog.setAttribute('aria-describedby', 'update-message');
  dialog.innerHTML = `<div class="ranking-heading"><h2 id="update-title">本次更新</h2></div>
    <p id="update-message">本次更新加入四款新皮肤，优化声音效果。祝大家勇攀高峰</p>
    <button type="button" autofocus>知道了</button>`;
  ui.appendChild(dialog);
  dialog.querySelector('button').onclick = () => dialog.close();
  dialog.addEventListener('close', () => {
    try { localStorage.setItem(STORAGE_KEY, VERSION); } catch (_) {}
    dialog.remove();
  }, {once: true});
  dialog.showModal();
}
